import { h } from 'preact';

import NewsItem from './components/NewsItem';

export default function ViewNewsItem({
	newsitems,
	focusNewsItem
}){

	return (
		<div class="news-filter-newsitems-container">
			{newsitems.length > 0 ?
				newsitems.map((newsitem, index) => <NewsItem {...newsitem} isFocussed={focusNewsItem ? index === focusNewsItem : false} /> ) : 'Geen berichten gevonden'
			}
		</div>
	);
}
